import { render, staticRenderFns } from "./Esports.vue?vue&type=template&id=d05afa28&scoped=true&"
import script from "./Esports.vue?vue&type=script&lang=js&"
export * from "./Esports.vue?vue&type=script&lang=js&"
import style0 from "./Esports.vue?vue&type=style&index=0&id=d05afa28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d05afa28",
  null
  
)

export default component.exports